import { useRef } from 'react';

import { useAppSelector } from '@/configuration/setup/hooks';
import { getNewLocationId, getOldLocationId } from '@/features/app/locationSlice';

const useShouldSkipQuery = () => {
    const oldLocationId = useAppSelector(getOldLocationId);
    const newLocationId = useAppSelector(getNewLocationId);

    const previousLocationRef = useRef<string | undefined>(undefined);

    const isBackFromDetailView =
        newLocationId === 'VEHICLE_STATUS' &&
        oldLocationId === 'DETAIL_VIEW' &&
        previousLocationRef.current !== newLocationId;

    previousLocationRef.current = newLocationId;

    const shouldSkip = newLocationId !== 'VEHICLE_STATUS' || isBackFromDetailView;

    return { shouldSkip, oldLocationId, newLocationId };
};

export default useShouldSkipQuery;
